import React, { useEffect, useRef } from 'react';

export default function useEffectOnceWhen(
  callback: () => void,
  condition: React.ReactNode = true,
): void {
  const hasRunOnceRef = useRef(false);
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    if (condition && !hasRunOnceRef.current) {
      callbackRef.current();
      hasRunOnceRef.current = true;
    }
  }, [condition]);
}
